import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// @mui
import { Box, Modal, Button, Stack, TextField } from '@mui/material';
import { cores } from '../../../styles/styleUtils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  height: '50vh',
  '@media screen and (max-width: 600px)': {
    width: '50vw', // Width de 100% para telas de celulares
    height: '50vh',
  },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  backgroundColor: cores.branco,
  alignItems: 'center',
  justifyContent: 'center',
};

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const CancelarProposta = React.forwardRef((props, ref) => {
  const [obs, setObs] = useState(null);

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box mb={5}>
          <strong>Informe o motivo</strong>
        </Box>

        <TextField
          id="obs"
          label="Descrição"
          variant="outlined"
          value={obs || ''}
          multiline
          rows={4}
          onChange={(e) => setObs(e.target.value)}
          sx={{ width: '70%', backgroundColor: cores.branco, mt: 1 }}
        />
        <Stack direction={'row'} justifyContent={'space-between'} gap={20} mt={5}>
          <Button variant="outlined" onClick={props.onClose} color="error">
            {' '}
            Cancelar
          </Button>
          <Button variant="contained" disabled={!obs} color="success" onClick={() => props.onConfirm(obs)}>
            Confirmar
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
});

CancelarProposta.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default CancelarProposta;